import React from 'react';
import style from './CopyLinkCard.module.scss';
import {envConfig} from './../../API/enviromentVariables';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {ReactComponent as CopyIcon} from './../../assets/images/icons/copy.svg';
import copy from 'copy-to-clipboard';
import {useTranslation} from "react-i18next";
import {selectMediakitUser} from './../../features/stores/mediakitUser.slice';

const url = envConfig().copyLinkUrl;
const CopyLinkCard = (): JSX.Element => {
  const {t} = useTranslation();
  const linksUser = useSelector(selectMediakitUser);

  return (
    <div className={style.header}>
      <div className={`${style.input_wrapper}`}>
        <input
          className={`${style.input_field} ${style.input}`}
          value={`${url}/${linksUser?.nickname?.toLowerCase()}`}
          onChange={()=>{}}
          disabled
        />
        <div className={style.input_wrapper__icons}>
          <div className={style.icon_wrapper} onClick={() => {
            copy(`${url}/${linksUser?.nickname?.toLowerCase()}`);
            toast(<span style={{color: 'black'}}>{t('copy_link_success')}</span>, {
              autoClose: 9000,
            });
          }}>
            <div><CopyIcon stroke={'#F0F0FF'} /></div>
            <div className={style.icon_wrapper}>
              {/* <img src={copyIcon}></img> */}
              {/* <p>{t('copy_link')}</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default CopyLinkCard;
